import ActionButtons from "./ActionButtons"
import AprRow from "./AprRow"
import React from "react"
import RecommendSection from "./RecommendSection"
import { Box } from "@mui/material"
import { FER, XFER } from "src/constants"
import { usePoolTokenBalances } from "src/state/wallet/hooks"
import { FixedNumber } from "ethers"
import { useTranslation } from "react-i18next"
import useXFerRate from "../../hooks/useXFerRate"
import { useUserFerroBoost } from "src/state/xFer/hooks"
import { BIG_ZERO } from "src/constants/bigNumber"
import { formatNumber, getRawAmount } from "src/utils/parseStringToBigNumber"
import Text from "src/components/Text"
import CustomCard from "src/components/CustomCard"

interface Props {
  apr: number
}

const BarCard = ({ apr }: Props) => {
  const { t } = useTranslation()
  const tokenBalances = usePoolTokenBalances()
  const balance = tokenBalances?.[XFER.symbol] || BIG_ZERO
  const { boostData } = useUserFerroBoost()
  const rate = useXFerRate()

  const totalLocked = boostData.stakes
    .filter((x) => x.active)
    .map((x) => x.amount)
    .reduce((a, b) => a.add(b), BIG_ZERO)

  const totalXFer = balance.add(totalLocked)

  return (
    <Box>
      <Box mb={3}>
        <AprRow apr={apr} text={t("LAST 7 DAYS APR")} />
      </Box>
      <CustomCard variant="black50">
        <Box display="flex" justifyContent="space-between">
          <Box display="flex" alignItems="center">
            <img src={FER.icon} alt="$FER" />
            <Text ml={1}>{t("Total Value in FER")}</Text>
          </Box>
          <Text>
            {formatNumber(
              getRawAmount(
                FixedNumber.from(totalXFer).mulUnsafe(rate),
                XFER.decimals,
              ),
              2,
              2,
            )}
          </Text>
        </Box>
        <Box mt={3} display="flex" justifyContent="space-between">
          <Box display="flex" alignItems="center">
            <img src={XFER.icon} alt="$xFER" />
            <Text ml={1}>{t("Total xFER")}</Text>
          </Box>
          <Text>
            {formatNumber(getRawAmount(totalXFer, XFER.decimals), 2, 2)}
          </Text>
        </Box>
        <Box mt={1} display="flex" justifyContent="space-between">
          <Text>{t("Wallet")}</Text>
          <Text>
            {formatNumber(getRawAmount(balance, XFER.decimals), 2, 2)}
          </Text>
        </Box>
        <Box mt={1} display="flex" justifyContent="space-between">
          <Text>{t("Vaults")}</Text>
          <Text>
            {formatNumber(getRawAmount(totalLocked, XFER.decimals), 2, 2)}
          </Text>
        </Box>
        <Text
          my="16px"
          bgcolor="#009BE0"
          display="inline-block"
          py="4px"
          px="8px"
          borderRadius="16px"
          gradient="gradient-orange"
          size="micro"
        >
          {`1 xFER = ${formatNumber(rate, 2, 6)} FER`}
        </Text>
        <ActionButtons />
      </CustomCard>
      <RecommendSection />
    </Box>
  )
}

export default BarCard
